export default __webpack_public_path__ + "img/1_6-a5c65028.png";